import React, { Component } from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { connect } from 'react-redux';

import { FacebookAuthButton } from './style';

import { config } from '../../../Configurations';
import { UserActionCreators } from '../../../Store/ActionCreators/UserActionCreators';

class FacebookAuth extends Component {
    handleFacebookAuthResponse = token => this.props.authWithFacebook(token);
    renderFacebookButton = () => ({ onClick }) => (
        <FacebookAuthButton onClick={onClick}>Continue with Facebook</FacebookAuthButton>
    );

    render() {
        const { responseFacebook, ...props } = this.props;
        return (
            <FacebookLogin
                isMobile={false}
                appId={config.facebookAppId}
                fields="name,email,picture"
                cssClass={'button-default'}
                callback={this.handleFacebookAuthResponse}
                render={this.renderFacebookButton(props)}
            />
        );
    }
}

const mapDispatchToProps = dispatch => ({
    authWithFacebook: token => dispatch(UserActionCreators.signInUserWithFacebookSuccess(token)),
});

export default connect(
    null,
    mapDispatchToProps,
)(FacebookAuth);



// WEBPACK FOOTER //
// ./src/UI/Containers/Authentication/FacebookAuth.js